import React from "react";
import {
  Box,
  Stack,
  Typography,
  Select,
  MenuItem,
  FormControl,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";

export default function BoardFilterBar({ filters, onChange, territories }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const isFiltered = filters.territory_id !== null;

  const handleTerritory = (e) => {
    const val = e.target.value;
    onChange({ ...filters, territory_id: val === "" ? null : val });
  };

  const handleClear = () => {
    onChange({ ...filters, territory_id: null });
  };

  const selectSx = {
    borderRadius: "10px",
    fontSize: "0.82rem",
    fontWeight: 500,
    height: 36,
    minWidth: 200,
    bgcolor: isDark ? "rgba(255,255,255,0.04)" : "#ffffff",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: isDark ? "rgba(255,255,255,0.14)" : "rgba(0,0,0,0.14)",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: isDark ? "rgba(255,255,255,0.28)" : "rgba(0,0,0,0.28)",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.primary.main,
    },
  };

  return (
    <Box
      sx={{
        borderRadius: "16px",
        border: `1px solid ${isDark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"}`,
        bgcolor: isDark ? "rgba(15,23,42,0.5)" : "rgba(255,255,255,0.8)",
        backdropFilter: "blur(8px)",
        px: 2.5,
        py: 1.5,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1.5} flexWrap="wrap">

        {/* Label */}
        <Stack direction="row" alignItems="center" spacing={0.75}>
          <FilterListIcon sx={{ fontSize: 15, color: "text.disabled" }} />
          <Typography
            variant="caption"
            color="text.disabled"
            fontWeight={600}
            sx={{ fontSize: "0.72rem", letterSpacing: "0.05em", textTransform: "uppercase" }}
          >
            Territory
          </Typography>
        </Stack>

        {/* Territory select */}
        <FormControl size="small">
          <Select
            value={filters.territory_id ?? ""}
            onChange={handleTerritory}
            displayEmpty
            sx={selectSx}
          >
            <MenuItem value="">
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.82rem" }}>
                All Territories
              </Typography>
            </MenuItem>
            {(territories || []).map((t) => (
              <MenuItem key={t.id} value={t.id}>
                <Typography variant="body2" sx={{ fontSize: "0.82rem" }}>
                  {t.name}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Clear — only when filtered */}
        {isFiltered && (
          <Tooltip title="Clear filter" arrow>
            <IconButton
              size="small"
              onClick={handleClear}
              sx={{
                color: "text.disabled",
                "&:hover": { color: "error.main" },
              }}
            >
              <ClearIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        )}

      </Stack>
    </Box>
  );
}
